import styled from '@emotion/styled';


export default styled.div`
        border-color: #e11d2a;
    border-bottom: solid 2px #e11d2a;
    border-right: none;
    border-left: none;
    border-top: 0px;
    width: 90%;
    height: 2px;
    margin: 0 5% 0 5%;


`